/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：aJKZ
 */

// removed by extract-text-webpack-plugin
module.exports = {
  "previewTemplate": "previewTemplate_3xQAV",
  "quitPreviewBtn": "quitPreviewBtn_1uZjq",
  "icon": "icon_1or6f",
  "templateList": "templateList_2-vzt",
  "templateItem": "templateItem_h5yLB",
  "imageBox": "imageBox_XTN5l",
  "gif": "gif_2Q2Pd",
  "image": "image_1PUQY",
  "name": "name_1Oc8V",
  "desc": "desc_xp7PJ",
  "blue": "blue_3OTiU",
  "yellow": "yellow_2zgMy",
  "purple": "purple_IP9eP",
  "active": "active_2yLFs",
  "previewBtnBox": "previewBtnBox_nPGIc",
  "btnItem": "btnItem_1pLKo",
  "howBtn": "howBtn_3vSZD",
  "content": "content_3CGme",
  "dropdown": "dropdown_2Crxb",
  "qrcodeImage": "qrcodeImage_1cOkY"
}

/***/
